import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {Breadcrumb, Button, Col, Form, Input, message, Modal, Row, Select, Space, Table, Tag} from "antd";
import {
    DownloadOutlined,
    ExclamationCircleOutlined,
    FileAddOutlined,
    FileSearchOutlined,
    FileTextOutlined,
    UploadOutlined
} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const SupplierGoodsIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [goodsPageIndex, setGoodsPageIndex] = useState(1);
    const [goodsPageSize, setGoodsPageSize] = useState(store.main.pageSize);
    const [goodsTotal, setGoodsTotal] = useState(0);
    const [goodsList, setGoodsList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/supplier/index"});

            handleSearchGoods();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadGoods(goodsPageIndex, goodsPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });


    const handleLoadGoods = (goodsPageIndex, goodsPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.spuStatus = data.spuStatus === "ALL" ? null : data.spuStatus;
        data.supplier = data.supplier === "ALL" ? null : data.supplier;
        data.pageIndex = goodsPageIndex;
        data.pageSize = goodsPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/zhiketong/supplierGoods/list",
            data: data,
            success: (response) => {
                setGoodsPageIndex(goodsPageIndex);
                setGoodsPageSize(goodsPageSize);
                setGoodsTotal(response.data.total);
                setGoodsList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                    response.data.total == "undefined" ||
                    response.data.total == null ||
                    response.data.list == "undefined" ||
                    response.data.list == null
                );
            },
        });
    };

    const pullAllSupplierGoods = () => {
        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认拉取全部？",
            content: "拉取全部,比较耗时,请耐心等候",
            icon: <ExclamationCircleOutlined/>,
            onOk() {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                let data = {
                    // "hotelId": "195640",
                    // "local": true
                };

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/zhiketong/product/init",
                    data: data,
                    success: (response) => {
                        message.success({
                            content: response.data.msg,
                            key: "isLoad",
                            duration: 2,
                        });
                    },
                    error: (response) => {
                        message.error({content: response.message, duration: 1});
                    },
                    complete: (response) => {
                        request.current = false;

                        setIsLoad(false);
                        let noOk = typeof response.data == "undefined";
                        setIsError(noOk);
                        if (!noOk) {
                            handleSearchGoods();
                        }
                    },
                });
            },
        });
    };


    const handlePullGoods = (supplierSpuId) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = {"supplierSpuId": supplierSpuId};

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/zhiketong/supplierGoods/pull",
            data: data,
            success: (response) => {
                message.success({
                    content: response.message,
                    key: "isLoad",
                    duration: 2,
                });
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                let noOk = typeof response.data == "undefined";
                setIsError(noOk);
                if (!noOk) {
                    handleSearchGoods();
                }
            },
        });
    };

    const handleAddGoods = (supplierSpuId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/goods/supplier/" + supplierSpuId,
        });
    };

    const handleEditGoods = (goodsId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/goods/edit/" + goodsId,
        });
    };

    const handleSearchGoods = () => {
        handleLoadGoods(1, goodsPageSize);
    };

    const handleChangeGoodsPagination = (goodsPageIndex, goodsPageSize) => {
        handleLoadGoods(goodsPageIndex, goodsPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button loading={isLoad} icon={<FileAddOutlined/>} size="large"
                                    onClick={pullAllSupplierGoods}>
                                拉取全部
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined/>} type="primary" size="large"
                                onClick={handleSearchGoods}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError}
                                 isScroll={store.main.isFixedContent}>
                <div style={{fontSize:"12px",color:"#6e6d6d",marginBottom:"20px"}}>*提示：当前页面商品信息为供货渠道同步来的数据，可通过导入操作进行商品入库。</div>
                <Form form={form}>
                    <Row>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="供货渠道"
                                labelAlign={"left"}
                                name="supplier"
                                initialValue={"ALL"}
                                rules={[
                                    {
                                        required: false,
                                        message: "请选择供货渠道",
                                    },
                                ]}
                            >
                                <Select className={Style.card_field} placeholder="请选择供货渠道" allowClear
                                        onChange={handleSearchGoods}>
                                    <Select.Option value={"ALL"}>全部</Select.Option>
                                    <Select.Option value={"ZHI_KE_TONG"}>直客通</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="商品名称"
                                labelAlign={"left"}
                                name="goodsName"
                                initialValue={null}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入商品名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入商品名称" allowClear
                                       onPressEnter={handleSearchGoods}/>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="酒店名称"
                                labelAlign={"left"}
                                name="merchantName"
                                initialValue={null}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入酒店名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入酒店名称" allowClear
                                       onPressEnter={handleSearchGoods}/>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="城市名称"
                                labelAlign={"left"}
                                name="cityName"
                                initialValue={null}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入城市名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入城市名称" allowClear
                                       onPressEnter={handleSearchGoods}/>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="选品状态"
                                labelAlign={"left"}
                                name="spuStatus"
                                initialValue={"ALL"}
                                rules={[
                                    {
                                        required: false,
                                        message: "请选择状态",
                                    },
                                ]}
                            >
                                <Select className={Style.card_field} placeholder="请选择状态" allowClear
                                        onChange={handleSearchGoods}>
                                    <Select.Option value={"ALL"}>全部</Select.Option>
                                    <Select.Option value={"NOT_IMPORT"}>未导入</Select.Option>
                                    <Select.Option value={"IMPORT"}>已导入</Select.Option>
                                    <Select.Option value={"HAVE_UPDATE"}>有更新</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.supplierGoodsId}
                        columns={[
                            {
                                title: "供货渠道",
                                width: 100,
                                dataIndex: "supplier",
                                render: (value) => {
                                    switch (value) {
                                        case "ZHI_KE_TONG":
                                            return "直客通";
                                        default:
                                            return "";
                                    }
                                }
                            },
                            {
                                title: "酒店名称/酒店编号",
                                width: 180,
                                render: (text, record, recordIndex) =>(
                                    <React.Fragment>
                                        <div>{record.merchantName}</div>
                                        <div className={Style.hotel_id}>ID:{record.hotelId}</div>
                                    </React.Fragment>
                                )
                            },
                            {
                                title: "商品名称",
                                width: 180,
                                dataIndex: "goodsName",
                                render: (text, record, recordIndex) =>(
                                    <React.Fragment>
                                        <div>{record.goodsName}</div>
                                        <div className={Style.hotel_id}>SpuID:{record.supplierSpuId}</div>
                                    </React.Fragment>
                                )
                            },
                            {
                                title: "销售时间",
                                width: 160,
                                render: (text, record, recordIndex) => (
                                    <React.Fragment>
                                        <div>{record.sellDateStart } ~ </div>
                                        <div>{record.sellDateStop}</div>
                                    </React.Fragment>
                                )
                            },
                            {
                                title: "周可定日期",
                                width: 130,
                                render: (text, record, recordIndex) => (
                                    <React.Fragment>
                                        {record.goodsReserveWeekList.sort().map((goodsReserveWeek, goodsReserveWeekIndex) => {
                                            return (
                                                <span key={goodsReserveWeekIndex}>
                                                    {goodsReserveWeek == 0 ? null : goodsReserveWeek}
                                                    {goodsReserveWeekIndex + 1 < record.goodsReserveWeekList.length && goodsReserveWeek > 0
                                                        ? ","
                                                        : null}
                                                </span>
                                            );
                                        })}
                                        {record.goodsReserveWeekList.indexOf(0) > -1
                                            ? (record.goodsReserveWeekList.length > 1 ? "," : "") + "7"
                                            : null}
                                    </React.Fragment>
                                ),
                            },
                            {
                                title: "可定时间",
                                width: 110,
                                render: (text, record, recordIndex) => (
                                    <React.Fragment>
                                        {record.goodsReserveStartTime}~{record.goodsReserveEndTime}
                                    </React.Fragment>
                                ),
                            },
                            {
                                title: "省份/城市名称",
                                width: 110,
                                render: (text, record, recordIndex) => {
                                    return record.provinceName + "/" + record.cityName
                                }
                            },
                            {
                                title: "选品状态",
                                width: 110,
                                dataIndex: "spuStatus",
                                render: (value) => {
                                    switch (value) {
                                        case "IMPORT":
                                            return <Tag color="blue">已导入</Tag>;
                                        case "NOT_IMPORT":
                                            return <Tag color="yellow">未导入</Tag>;
                                        case "HAVE_UPDATE":
                                            return <Tag color="red">有更新</Tag>;
                                        default:
                                            return "";
                                    }
                                },
                            },
                            {
                                title: "操作",
                                fixed: "right",
                                width: 100,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        {record.spuStatus === "IMPORT" ? (
                                            <Button icon={<DownloadOutlined/>} size="default"
                                                    onClick={() => handlePullGoods(record.supplierSpuId)}>
                                                拉取
                                            </Button>) : null
                                        }
                                        {record.spuStatus === "NOT_IMPORT" ? (
                                            <Button icon={<UploadOutlined/>} size="default"
                                                    onClick={() => handleAddGoods(record.supplierSpuId)}>
                                                导入
                                            </Button>) : null
                                        }
                                        {record.spuStatus === "HAVE_UPDATE" ? (
                                            <Button icon={<FileTextOutlined/>} size="default"
                                                    onClick={() => handleEditGoods(record.goodsId)}>
                                                更新
                                            </Button>) : null
                                        }
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={goodsList}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: goodsPageIndex,
                            pageSize: goodsPageSize,
                            total: goodsTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeGoodsPagination,
                            onShowSizeChange: handleChangeGoodsPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

SupplierGoodsIndex.propTypes = {};

SupplierGoodsIndex.defaultProps = {};

export default SupplierGoodsIndex;
